import { render } from "./StepAuto.vue?vue&type=template&id=f3edfd90&ts=true"
import script from "./StepAuto.vue?vue&type=script&lang=ts"
export * from "./StepAuto.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__